import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinedCardZeroState = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 295,
	height: 142,
	viewBox: "0 0 295 142",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H291C292.933 0.5 294.5 2.067 294.5 4V39.5H0.5V4Z",
			stroke: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 102.5H294.5V138C294.5 139.933 292.933 141.5 291 141.5H4.00001C2.06701 141.5 0.5 139.933 0.5 138V102.5Z",
			fill: "#F8F9FB",
			stroke: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 39.5,
			width: 294,
			height: 63,
			fill: "white",
			stroke: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 55,
			width: 32,
			height: 32,
			rx: 2,
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 15,
			width: 80,
			height: 8,
			rx: 2,
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 118,
			width: 80,
			height: 8,
			rx: 2,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 226,
			y: 118,
			width: 56,
			height: 8,
			rx: 2,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64,
			y: 60,
			width: 80,
			height: 8,
			rx: 2,
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 232,
			y: 60,
			width: 47,
			height: 8,
			rx: 2,
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64,
			y: 76,
			width: 60,
			height: 4,
			rx: 2,
			fill: "#EEF1F6"
		})
	]
});
const ForwardRef = forwardRef(SvgLinedCardZeroState);
export { ForwardRef as ReactComponent };
